export default __webpack_public_path__ + "static/media/two.a5ff5d82.jpg";